"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FitpayApi = exports.useV3Stripe = void 0;
var infrastructure_const_1 = require("@const/infrastructure.const");
var backend_services_1 = require("@src/services/backend-services");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
exports.useV3Stripe = true;
var FitpayApi = /** @class */ (function () {
    function FitpayApi() {
    }
    /**
     * Creates a onetime payment intent
     * @param configuration
     * @returns
     */
    FitpayApi.prototype.createPaymentIntent = function (configuration_1, termId_1, name_1, email_1, studioId_1, studioName_1) {
        return __awaiter(this, arguments, void 0, function (configuration, termId, name, email, studioId, studioName, modules) {
            var cloudUrl, testProd, fittecId, onetimePayment, price, accountId, response, errorDetails, e_1;
            var _a, _b;
            if (modules === void 0) { modules = []; }
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, configuration.environment) +
                            '/create-payment-intent' +
                            (exports.useV3Stripe ? '-v3' : '');
                        testProd = localStorage.getItem('testPayment');
                        fittecId = configuration.fittecId;
                        onetimePayment = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.isOnetimePayment) === 'true';
                        price = +(0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundlePrice);
                        accountId = (_b = (_a = configuration.stripe) === null || _a === void 0 ? void 0 : _a.stripeStudioMapping) === null || _b === void 0 ? void 0 : _b[studioId];
                        if (!accountId) {
                            console.error('Missing account id for studio ' + studioId);
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                                headers: { 'Content-Type': 'application/json' },
                                method: 'POST',
                                body: JSON.stringify({
                                    tenantKey: configuration.tenantKey,
                                    fittecId: fittecId,
                                    accountId: accountId,
                                    redirectUrl: window.location.href.split('?')[0],
                                    name: name,
                                    email: email,
                                    studioId: studioId,
                                    studioName: studioName,
                                    termId: termId,
                                    optionalModules: modules,
                                    testPayment: testProd === 'true',
                                    onetimePayment: onetimePayment,
                                    price: price,
                                }),
                            })];
                    case 2:
                        response = _c.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        errorDetails = _c.sent();
                        console.error('Payment intent error:', errorDetails);
                        return [2 /*return*/, undefined];
                    case 4: return [4 /*yield*/, response.json()];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6:
                        e_1 = _c.sent();
                        console.error('Payment intent failed:', e_1);
                        return [2 /*return*/, undefined];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Capture a payment (can be subscription or onetime payment)
     * @param customer
     * @param config
     * @param intent
     * @param paymentMethodId
     * @returns
     */
    FitpayApi.prototype.capturePayment = function (customer, config, intent, paymentMethodId) {
        return __awaiter(this, void 0, void 0, function () {
            var cloudUrl, accountId, paymentMethodName, testProd, manychat, onetimePayment, funnelId, response, result, key;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, config.get.environment) + '/capture-payment' + (exports.useV3Stripe ? '-v3' : '');
                        console.log('capturing payment', intent, 'customer', 'at url', customer, cloudUrl);
                        accountId = (_c = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.stripe) === null || _b === void 0 ? void 0 : _b.stripeStudioMapping) === null || _c === void 0 ? void 0 : _c[customer.studioId];
                        if (!accountId) {
                            console.error('Missing account id for studio ' + customer.studioId);
                            return [2 /*return*/];
                        }
                        if (!((_e = (_d = customer.customer) === null || _d === void 0 ? void 0 : _d.countryCode) === null || _e === void 0 ? void 0 : _e.length)) {
                            customer.customer.countryCode = 'DE';
                        }
                        paymentMethodName = localStorage.getItem('selectedPaymentMethod') || 'card';
                        testProd = localStorage.getItem('testPayment');
                        manychat = localStorage.getItem('manychat-lead-id');
                        onetimePayment = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.isOnetimePayment) === 'true';
                        funnelId = config.get.funnelConfigId;
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                                headers: { 'Content-Type': 'application/json' },
                                method: 'POST',
                                body: JSON.stringify(__assign(__assign({ tenantKey: config.get.tenantKey, fittecId: intent.fittecId, stripe: {
                                        accountId: accountId,
                                        customerId: intent.customerId,
                                        onetimePayment: onetimePayment,
                                    }, studioId: customer.studioId, magiclineCustomerContract: customer, paymentIntentId: intent.paymentIntentId, paymentMethodId: paymentMethodId, paymentMethodName: paymentMethodName, leadhash: localStorage.getItem('leadhash'), testPayment: testProd === 'true', aov: customer.aov }, ((manychat === null || manychat === void 0 ? void 0 : manychat.length) ? { manychat: manychat } : {})), (funnelId ? { funnelId: funnelId } : {}))),
                            })];
                    case 1:
                        response = _f.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        result = _f.sent();
                        try {
                            if (result.customerCreationResult) {
                                for (key in result.customerCreationResult) {
                                    if (result.customerCreationResult[key]) {
                                        localStorage.setItem(key, result.customerCreationResult[key]);
                                    }
                                }
                            }
                        }
                        catch (e) {
                            console.log('Failed setting localstorage from customer creation result');
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Creates a onetime payment intent
     * @param configuration
     * @returns
     */
    FitpayApi.prototype.createMissingPaymentIntent = function (configuration, missingPaymentDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var cloudUrl, testProd, missingPaymentParams, returnUrl, response, errorDetails, e_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, configuration.environment) + '/create-missing-payment-intent';
                        testProd = localStorage.getItem('testPayment');
                        missingPaymentParams = missingPaymentDetails
                            ? '?' +
                                new URLSearchParams({
                                    email: missingPaymentDetails.email,
                                    geburtstag: missingPaymentDetails.birthday,
                                }).toString()
                            : '';
                        returnUrl = window.location.href.split('?')[0] + missingPaymentParams;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                                headers: { 'Content-Type': 'application/json' },
                                method: 'POST',
                                body: JSON.stringify({
                                    tenantKey: configuration.tenantKey,
                                    fittecId: configuration.fittecId,
                                    redirectUrl: returnUrl,
                                    missingPaymentDetails: missingPaymentDetails,
                                    stripeStudioMapping: (_a = configuration.stripe) === null || _a === void 0 ? void 0 : _a.stripeStudioMapping,
                                    testPayment: testProd === 'true',
                                }),
                            })];
                    case 2:
                        response = _c.sent();
                        if (!!response.ok) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3:
                        errorDetails = _c.sent();
                        console.error('Payment intent error:', errorDetails);
                        return [2 /*return*/, { error: (_b = errorDetails.message) !== null && _b !== void 0 ? _b : 'Something went wrong checking your balance.' }];
                    case 4: return [4 /*yield*/, response.json()];
                    case 5: return [2 /*return*/, _c.sent()];
                    case 6:
                        e_2 = _c.sent();
                        console.error('Payment intent failed:', e_2);
                        return [2 /*return*/, { error: 'Something went wrong checking your balance.' }];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Capture a missing payment
     * @param config
     * @param intent
     * @param magiclineCustomerId
     * @returns
     */
    FitpayApi.prototype.captureMissingPayment = function (config, intent) {
        return __awaiter(this, void 0, void 0, function () {
            var cloudUrl, paymentMethodName, response;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        cloudUrl = (0, infrastructure_const_1._GetCloudFunctionUrl)(infrastructure_const_1._CloudFunctionTypes.fitpay, config.get.environment) + '/capture-missing-payment';
                        console.log('capturing missing payment', intent, 'customer', 'at url', cloudUrl);
                        paymentMethodName = localStorage.getItem('selectedPaymentMethod') || 'card';
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)(cloudUrl, {
                                headers: { 'Content-Type': 'application/json' },
                                method: 'POST',
                                body: JSON.stringify({
                                    tenantKey: config.get.tenantKey,
                                    paymentIntentId: intent.paymentIntentId,
                                    stripeAccount: (_a = intent.customer) === null || _a === void 0 ? void 0 : _a.stripeAccount,
                                    studioId: (_b = intent.customer) === null || _b === void 0 ? void 0 : _b.studioId,
                                    paymentMethodName: paymentMethodName,
                                    stripeCustomerId: intent.customerId,
                                }),
                            })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    /**
     * Takes google pay name and splits it into first and last name
     * @param name
     * @returns
     */
    FitpayApi.prototype.nameToFirstNameAndLastName = function (name) {
        var nameParts = name.trim().split(/\s+/); // Split by whitespace
        if (nameParts.length === 1) {
            // Only one name part, assume it's the first name
            return { firstName: nameParts[0], lastName: '' };
        }
        else {
            // First part is the first name, the rest are combined as the last name
            return {
                firstName: nameParts[0],
                lastName: nameParts.slice(1).join(' '), // Join middle and last name together
            };
        }
    };
    FitpayApi.prototype.addressLineToStreetAndHouseNumber = function (addressLine) {
        if (!addressLine) {
            return {
                street: '',
                houseNumber: '',
            };
        }
        var regex = /^(.*?)(\d+\s*[a-zA-Z]?)\s*$/;
        var match = addressLine.match(regex);
        if (match) {
            return {
                street: match[1].trim(),
                houseNumber: match[2].trim(),
            };
        }
        return {
            street: addressLine,
            houseNumber: '',
        };
    };
    return FitpayApi;
}());
exports.FitpayApi = FitpayApi;
